import React from "react"
import {
  // eslint-disable-next-line no-unused-vars
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Button,
  // eslint-disable-next-line no-unused-vars
  Slide,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
} from "@material-ui/core"
import {
  Close as CloseIcon,
  CheckCircleOutline as CheckCircleOutlineIcon,
  CropFree,
  Edit,
} from "@material-ui/icons"
import { StyledButton } from "src/components/Buttons/TgButton"
import useStyles from "src/views/viewAdministrador/areasComunales/useStyle"

/**
 * @typedef CustomProps
 * @type {object}
 * @property {string} [title] texto para el header del modal
 * @property {String} [textCancel] by default "Cancelar"
 * @property {String} [textConfirm] by default "Confirmar"
 * @property {Function} [handleCancel] event click for cancel button by default "onClose" property
 * @property {Function} [handleConfirm] event click for confirm button by default any
 * @property {Boolean} [withTransition] true to dialog transition effect, by default false
 * @property {Boolean} [showActions] default "true", show action buttons
 * @property {Boolean} [showHeader] default "false", show custom DialogHeader
 * @property {SlideProps} [transitionProps] transitionProps, it will be applied if "withTransition" is set to true
 */

/**
 * @type React.FC<(DialogProps|CustomProps)>
 * Custom Dialog que requiere solo el contenido del Dialog
 * @returns JSX.Element
 */

const CustomDialog = ({
  title = "Mi casita",
  handleCancel,
  handleConfirm,
  textCancel = "Cancelar",
  textConfirm = "Confirmar",
  withTransition = false,
  showActions = true,
  showHeader = false,
  showQrOption = false,
  handleQr,
  transitionProps = {},
  children,
  onClose,
  showEdit,
  handleEdit,
  ...rest
}) => {
  const classes = useStyles() // 🔹 La clase debe inicializarse dentro del cuerpo de la función correctamente

  return (
    <Dialog
      TransitionComponent={
        withTransition ? <Transition {...transitionProps} /> : undefined
      }
      onClose={onClose}
      {...rest}
    >
      {showHeader ? (
        <Header title={title} onClose={onClose} />
      ) : (
        <DialogTitle disableTypography>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gridGap={16}
          >
            <Typography component="h2" variant="h4">
              {title}
            </Typography>
            {onClose && (
              <IconButton size="small" onClick={onClose} aria-label="Cerrar">
                <CloseIcon />
              </IconButton>
            )}
          </Box>
        </DialogTitle>
      )}
      <DialogContent dividers>{children}</DialogContent>
      {showActions && (
        <DialogActions>
          {showQrOption && (
            <Button
              onClick={() => {
                handleQr()
              }}
              variant="outlined"
              color="primary"
            >
              <CropFree className="me-2" />
              Ver Qr
            </Button>
          )}
          {showEdit && (
            <Button
              onClick={() => {
                handleEdit()
              }}
              variant="outlined"
              color="primary"
            >
              <Edit className="me-2" />
              Editar
            </Button>
          )}
          <StyledButton
            onClick={handleCancel || onClose}
            variant="outlined"
            color="primary"
          >
            <CloseIcon className={classes.iconRed} />
            {handleCancel ? textCancel : "Cerrar"}
          </StyledButton>
          {handleConfirm && (
            <StyledButton
              onClick={handleConfirm}
              variant="contained"
              color="primary"
            >
              <CheckCircleOutlineIcon className={classes.iconGreen} />
              {textConfirm}
            </StyledButton>
          )}
        </DialogActions>
      )}
    </Dialog>
  )
}

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
))

const Header = ({ title, onClose }) => (
  <AppBar className="position-relative">
    <Toolbar>
      <IconButton
        edge="start"
        color="inherit"
        onClick={onClose}
        aria-label="close"
      >
        <CloseIcon />
      </IconButton>
      <Typography variant="h6" className="d-flex flex-grow-1">
        {title}
      </Typography>
    </Toolbar>
  </AppBar>
)

export default CustomDialog
